require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-kirby-shabaga.json") })
        }
      }, "path---blog-author-kirby-shabaga");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-kirby-shabaga!./.cache/json/blog-author-kirby-shabaga.json
// module id = 670
// module chunks = 231608221292675